import { Input } from "common/InputForm";
import useButtonLoader from "common/UseButtonLoader";
import { CustomModal } from "components/modals/ModalBox";
import { useState } from "react";
import { addBrandApi } from "services/brand";
import { toastMessage } from "utils/toastMessage";

export const AddProductBrandModel = ({ setAddModal, addModal, brandListHandler }) => {
  const [errors, setErrors] = useState({});
  const [inputData, setInputData] = useState({
    name: "",
    logo: "",
    brandType: "",
  });
  const [buttonLoaders, setButtonLoaders] = useButtonLoader("Add");
  const validation = () => {
    let isValid = true;
    const error = {};

    if (!inputData.name) {
      error["name"] = "Please enter a Brand name";
      isValid = false;
    }

    if (!inputData.orderNumber) {
      error["orderNumber"] = "Please select orderNumber";
      isValid = false;
    }
    
    setErrors(error);
    return isValid;
  };
  const onChangeHandler = (e) => {
    const { name, value } = e.target;
    setInputData({ ...inputData, [name]: value });
  };
  const addBrand = async (e) => {
    e.preventDefault();
    if (validation()) {
      setButtonLoaders(true);
      try {
        const formData = new FormData();
        formData.append("name", inputData.name);
        formData.append("orderNumber",inputData.orderNumber)
        formData.append("type", "product");
        const res = await addBrandApi(formData);
        if (res?.data?.status === 200) {
          toastMessage(res?.data?.message, "success", "addBrand");
          setInputData({ name: "", logo: "", brandType: "" });
          setAddModal(false);
          brandListHandler();
        } 
      } catch (e) {
        console.log("Error:", e.message);
      } finally {
        setButtonLoaders(false);
      }
    }
  };

  return (
    <CustomModal
      className={"add_model"}
      show={addModal}
      handleClose={() => {
        setAddModal(false);
        setInputData({ name: "", logo: "", brandType: "" });
        setErrors({});
      }}
    >
      <h3>Add Product Brand</h3>
      <div className="add_model">
        {/* Brand Name */}
        <div className="form_field">
          <Input
            className={"form-control input"}
            label={"Brand Name"}
            type={"text"}
            value={inputData.name || ""}
            onChange={onChangeHandler}
            placeholder={"Enter Brand Name"}
            name={"name"}
            error={errors?.name}
          />
        </div>
     
        <div className="form_field">
          <Input
            className={"form-control input"}
            label={"Order Number"}
            type={"number"}
            value={inputData.orderNumber || ""}
            onChange={onChangeHandler}
            placeholder={"Enter Order Number"}
            name={"orderNumber"}
            error={errors?.orderNumber}
          />
        </div>
      </div>

      <div className="button_wrap">
        <button
          type="button"
          className="button light"
          onClick={() => setAddModal(false)}
        >
          Cancel
        </button>
        <button
          type="button"
          ref={buttonLoaders}
          onClick={addBrand}
          className="button"
        >
          Submit
        </button>
      </div>
    </CustomModal>
  );
};
